import { CyclePhase, HormoneType } from './types';

// Standard hormone levels by phase (0-100 scale)
export const hormoneBaselines: Record<CyclePhase, Record<HormoneType, number[]>> = {
  menstruation: {
    estrogen: [10, 15, 20, 25, 30],
    progesterone: [5, 5, 5, 5, 5],
    testosterone: [30, 35, 40, 45, 50],
    fsh: [40, 50, 60, 70, 75],
    lh: [20, 20, 25, 30, 35]
  },
  follicular: {
    estrogen: [30, 40, 50, 60, 70, 80],
    progesterone: [5, 5, 5, 5, 8, 10],
    testosterone: [50, 55, 60, 65, 70, 75],
    fsh: [75, 70, 65, 60, 55, 50],
    lh: [35, 35, 35, 40, 45, 50]
  },
  ovulation: {
    estrogen: [90, 95, 100],
    progesterone: [15, 25, 35],
    testosterone: [80, 85, 90],
    fsh: [30, 20, 10],
    lh: [90, 100, 85]
  },
  luteal: {
    estrogen: [70, 60, 55, 50, 45, 40, 35],
    progesterone: [60, 70, 80, 95, 100, 90, 70],
    testosterone: [65, 60, 55, 50, 45, 40, 35],
    fsh: [10, 10, 10, 10, 15, 20, 25],
    lh: [30, 25, 20, 20, 20, 20, 20]
  },
  // Aliases to ensure all phases are covered
  menstrual: {
    estrogen: [10, 15, 20, 25, 30],
    progesterone: [5, 5, 5, 5, 5],
    testosterone: [30, 35, 40, 45, 50],
    fsh: [40, 50, 60, 70, 75],
    lh: [20, 20, 25, 30, 35]
  },
  ovulatory: {
    estrogen: [90, 95, 100],
    progesterone: [15, 25, 35],
    testosterone: [80, 85, 90],
    fsh: [30, 20, 10],
    lh: [90, 100, 85]
  },
  premenstrual: {
    estrogen: [30, 25, 20, 15],
    progesterone: [50, 30, 15, 10],
    testosterone: [30, 25, 25, 30],
    fsh: [30, 35, 40, 40],
    lh: [20, 20, 20, 20]
  }
};

export const phaseColors = {
  menstruation: '#F9D3C9', // Light coral for menstruation
  follicular: '#E5D7C9',   // Beige for follicular
  ovulatory: '#DAC9B9',    // Sand for ovulatory
  luteal: '#E27D60',       // Coral for luteal
  premenstrual: '#D16A54', // Dark coral for premenstrual
  // Aliases
  menstrual: '#F9D3C9',
  ovulation: '#DAC9B9'
};

export const hormoneColors = {
  estrogen: '#E27D60', // Coral
  progesterone: '#B8A99A', // Taupe
  testosterone: '#D16A54', // Dark coral
  fsh: '#91adaf', // Blue-gray
  lh: '#DAC9B9' // Sand
};

// Adding the missing hormoneDescriptions constant
export const hormoneDescriptions: Record<HormoneType, string> = {
  estrogen: 'Primary female sex hormone responsible for reproductive and sexual development. Levels fluctuate throughout the menstrual cycle.',
  progesterone: 'Hormone released by the corpus luteum that stimulates the uterus to prepare for pregnancy. Peaks during luteal phase.',
  testosterone: 'Hormone that affects sex drive, bone density, fat distribution, muscle strength and mass. Present in lower amounts in women.',
  fsh: 'Follicle Stimulating Hormone promotes the growth of ovarian follicles and stimulates estrogen production.',
  lh: 'Luteinizing Hormone triggers ovulation and the development of the corpus luteum. Surges during ovulation.'
};

export const phaseDescriptions: Record<string, string> = {
  menstruation: 'Uterus lining begins to break down and menstruation occurs',
  follicular: 'Lining of womb starts to thicken in preparation for egg',
  ovulatory: 'Ovulation occurs as the mature egg is released',
  luteal: 'If fertilisation has not occurred, the corpus luteum fades away',
  premenstrual: 'Uterine lining detaches and menstruation begins',
  // Aliases
  menstrual: 'Uterus lining begins to break down and menstruation occurs',
  ovulation: 'Ovulation occurs as the mature egg is released'
};

export const phaseDurations = {
  menstrual: 5,
  follicular: 6,
  ovulatory: 3,
  luteal: 7,
  premenstrual: 4,
  // Aliases
  menstruation: 5,
  ovulation: 3
};
